let currentIndex = 1;

function changeTab(clickedTab, tabIndex) {
  const tabs = document.querySelectorAll('.app-doctors-section .tab');
  tabs.forEach((tab) => {
    tab.classList.remove('active');
  });

  clickedTab.classList.add('active');

  const contentSections = document.querySelectorAll('.app-doctors-section .content-section');
  contentSections.forEach((section) => {
    section.classList.remove('active');
  });
  document.getElementById(`content${tabIndex}`).classList.add('active');

  const doctorImages = document.querySelectorAll('.app-doctors-section .doctor-image');
  doctorImages.forEach((img) => {
    img.style.display = 'none';
  });

  document.querySelectorAll('.app-doctors-section .doctor-image')[tabIndex - 1].style.display = 'block';

  currentIndex = tabIndex;

  const nonActiveTabs = document.querySelectorAll('.app-doctors-section .tab:not(.active)');
  nonActiveTabs.forEach((tab) => {
    const progressCircle = tab.querySelector('.app-doctors-section .progress-circle');
    if (progressCircle) {
      progressCircle.remove();
    }
  });
}
changeTab(document.querySelector('.app-doctors-section .tab'), 1);